import { UUID } from '@litlingo/client';
import React from 'react';
import { getCommEnvelopeReviewHistory } from 'selectors/envelopes';
import { useSelector } from 'store';
import EnvelopeYearLogList from './EnvelopeYearLogList';

type ComponentProps = {
  envelopeId: UUID;
};

const EnvelopeSidebarDetails: React.FC<ComponentProps> = ({ envelopeId }) => {
  const actions = useSelector((state) => getCommEnvelopeReviewHistory(state, envelopeId));
  const entries = Object.entries(actions).reverse();

  return (
    <div className="max-h-136 flex flex-col custom-scrollbar overflow-auto bg-white border border-litlingo-gray-1">
      {entries.length > 0 &&
        entries.map(([year, sessions], idx) => (
          <EnvelopeYearLogList
            key={year}
            year={year}
            sessions={sessions}
            includeSentMessage={idx === entries.length - 1}
          />
        ))}
      {entries.length <= 0 && (
        <div className="p-4 text-body italic">
          Review context like the selections made on the coding panel will be shown here.
        </div>
      )}
    </div>
  );
};

export default EnvelopeSidebarDetails;
